(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const updatePellHeader = () => {
      document.body.classList.toggle('pell-nav-scrolled', Boolean(document.querySelector('pell-collection-story')) && window.scrollY > 40);
    };
    window.addEventListener('scroll', updatePellHeader, { passive: true });
    document.addEventListener('shopify:section:load', updatePellHeader);
    updatePellHeader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pell-collection-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pell-collection-story')) {
    customElements.define('pell-collection-story', class extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('template') || this.observer) return;
        const root = document.querySelector('#MainContent');
        let scheduled = false;
        this.update = () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => { scheduled = false; this.placePhoto(); });
        };
        this.observer = new MutationObserver(this.update);
        this.observer.observe(root, { childList: true, subtree: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.update);
        this.photo?.remove();
      }
      placePhoto() {
        const list = document.querySelector('.boost-sd__product-list');
        const cards = list ? [...list.children].filter(el => el.classList.contains('boost-sd__product-item')) : [];
        const count = Number(this.dataset.breakAfter) || 8;
        if (!list || cards.length <= count || !cards[0].classList.contains('boost-sd__product-item-grid-view-layout')) { this.photo?.remove(); return; }
        const firstTop = cards[0].getBoundingClientRect().top;
        const columns = cards.filter(card => Math.abs(card.getBoundingClientRect().top - firstTop) < 2).length || 2;
        const after = Math.ceil(count / columns) * columns;
        if (cards.length <= after) { this.photo?.remove(); return; }
        if (!this.photo) this.photo = this.querySelector('template').content.firstElementChild.cloneNode(true);
        const anchor = cards[after - 1];
        if (anchor.nextElementSibling !== this.photo) anchor.after(this.photo);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pell-designer-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pell-designer-products')) {
    customElements.define('pell-designer-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.loadProducts();
      }
      async loadProducts() {
        try {
          const url = new URL(this.dataset.url, location.origin);
          url.searchParams.set('section_id', 'pell-designer-products');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = html.querySelector('[data-designer-results]');
          if (!results) return;
          const cards = [...results.querySelectorAll('[data-designer-product]')]
            .filter(card => card.dataset.designerProduct !== this.dataset.productId)
            .slice(0, Number(this.dataset.limit) || 4);
          if (!cards.length) { this.hidden = true; return; }
          this.querySelector('[data-designer-grid]').replaceChildren(...cards);
        } catch (error) {
          this.querySelector('[data-designer-grid]').hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
